import apiClient from '../api/api'
import { AnswerSubmissionPayload, AnswerSubmissionResponse, PreviewJD } from '@/interfaces/answer'
import { JobDescription } from '@/interfaces/jobDescription'

export const answerApi = {
  // Submit survey answers
  submitAnswers: async (payload: AnswerSubmissionPayload): Promise<AnswerSubmissionResponse> => {
    const response = await apiClient.post<AnswerSubmissionResponse>('/answers/submit', payload)
    return response.data
  },

  // Get preview JD (fallback, not used in normal flow)
  getPreviewJD: async (answerId: string): Promise<{ previewJD: PreviewJD; answerId: string }> => {
    const response = await apiClient.get<{ previewJD: PreviewJD; answerId: string }>(
      `/answers/${answerId}/preview-jd`
    )
    return response.data
  },

  // Confirm and save JD
  confirmJD: async (answerId: string, isAnonymous?: boolean): Promise<JobDescription> => {
    const response = await apiClient.post<JobDescription>(`/answers/${answerId}/confirm-jd`, {
      isAnonymous,
    })
    return response.data
  },
}
